import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PageHeader.css';

/**
 * Composant d'en-tête standardisé pour toutes les pages
 * Style : Minimaliste avec flèche seule
 *
 * @param {string} title - Titre de la page (obligatoire)
 * @param {boolean} showBackButton - Afficher le bouton retour (défaut: true)
 * @param {function} onBack - Handler custom pour le bouton retour (prioritaire sur backTo)
 * @param {string} backTo - URL de retour (défaut: '/') — ignoré si onBack est fourni
 * @param {string} backAriaLabel - Label accessible pour le bouton retour (défaut: 'Retour')
 * @param {React.ReactNode} actions - Boutons d'actions à droite (optionnel)
 * @param {boolean} sticky - Header sticky au scroll (défaut: true)
 * @param {React.ReactNode} children - Contenu additionnel sous le header principal (optionnel)
 * @param {string} className - Classes CSS additionnelles (optionnel)
 */
export function PageHeader({
  title,
  showBackButton = true,
  onBack = null,
  backTo = '/',
  backAriaLabel = 'Retour',
  actions = null,
  sticky = true,
  children = null,
  className = ''
}) {
  const navigate = useNavigate();
  const handleBack = onBack ?? (() => navigate(backTo));

  return (
    <header className={`page-header ${sticky ? 'sticky' : ''} ${className}`}>
      <div className="page-header-main">
        <div className="page-header-left">
          {showBackButton && (
            <button
              className="page-header-back-button"
              onClick={handleBack}
              aria-label={backAriaLabel}
              title={backAriaLabel}
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <polyline points="15 18 9 12 15 6"/>
              </svg>
            </button>
          )}
          <h1 className="page-header-title">{title}</h1>
        </div>
        {actions && (
          <div className="page-header-actions">
            {actions}
          </div>
        )}
      </div>
      {children && (
        <div className="page-header-extra">
          {children}
        </div>
      )}
    </header>
  );
}

export default PageHeader;
